import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminFTPQueueFiltersSelected = ({
  fileStatuses,
  selectedFileStatuses,
  handleChangeFilter,
}) => {
  const filteredSelectedFileStatuses = selectedFileStatuses.filter(i => (i !== 'all'));

  const isVisible = useMemo(
    () => Object.keys(fileStatuses).length > 0 && filteredSelectedFileStatuses.length > 0,
    [fileStatuses, filteredSelectedFileStatuses],
  );

  const intl = useIntl();

  return (
    <div className="filters-selected">
      {isVisible && (
        <div className="tags-list">
          {filteredSelectedFileStatuses.map(statusId => (
            <div key={`selected-status-${statusId}`} className="tag">
              <span
                className="tag-label"
                title={intl.formatMessage({ defaultMessage: 'Status: {status}' }, { status: fileStatuses[statusId] })}
              >
                {fileStatuses[statusId]}
              </span>
              {/* eslint-disable jsx-a11y/click-events-have-key-events */}
              <span
                className="tag-remove"
                title={intl.formatMessage({ defaultMessage: 'Remove' })}
                role="button"
                tabIndex={-1}
                onClick={() => {
                  handleChangeFilter({
                    target: {
                      name: 'selectedFileStatuses',
                      value: statusId,
                      checked: false,
                      type: 'checkbox',
                    },
                  });
                }}
              >
                <i className="far fa-times" />
              </span>
              {/* eslint-enable jsx-a11y/click-events-have-key-events */}
            </div>
          ))}
          <Button
            color="link"
            size="sm"
            onClick={() => {
              handleChangeFilter({
                target: {
                  name: 'selectedFileStatuses',
                  value: null,
                  checked: true,
                  type: 'checkbox',
                },
              });
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Clear all' })}
          </Button>
        </div>
      )}
    </div>
  );
};

AdminFTPQueueFiltersSelected.propTypes = {
  fileStatuses: PropTypes.object.isRequired,
  selectedFileStatuses: PropTypes.array.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
};

export default AdminFTPQueueFiltersSelected;
